import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-73947cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "install-auth-cell"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}

import { ref, reactive, computed, PropType, onMounted, nextTick, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import { FormType, FormSize, ObjectFormItem, DateType } from '@/components/cmForm/types'
import { useParseTime } from '@/hooks'
import {
  SoftGroup,
  AuthenticSoftListRow,
  SoftwareViewService
} from './software-view.service'
import { SoftmgrAuthenticSoftStatService, AuthenticRequestParams } from '../../service'
import { formatDuration, formatTimeStamp, unixSecondsOrUndefined } from '@/utils/time'
import dayjs from 'dayjs'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import InstalledDetail from './_components/installed-detail/installed-detail.vue'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'
import InstallStatisticsExport from '@/views/dashboard/manage/genuine-software-usage/_components/install-statistics-export/install-statistics-export.vue'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { listCol } from '@/utils/list-columns-i18n'
import { defaultAuthenticSoftUsageMonthRangeStrings } from '../../_utils/default-month-range'


export default /*#__PURE__*/_defineComponent({
  __name: 'software-view',
  props: {
  hasPermission: { type: Boolean, default: false },
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  /** 嵌入抽屉时传入：默认筛选项；重置时回到该基准（独立页不传） */
  embedDefaults: {
    type: Object as PropType<{
      authStatus?: number
      idleOnly?: boolean
      initialSoftName?: string
      /** 与正版使用页排行图请求区间一致 */
      initialDateRange?: [string, string]
    } | null>,
    default: null
  }
},
  emits: ['viewAll'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emits = __emit

const injector = useReflectiveInjector([SoftwareViewService, SoftmgrAuthenticSoftStatService])
const service = injector.get(SoftwareViewService)

const tableRef = ref<any>()
const { refreshList } = useCmTableListRefresh(tableRef)
const activeRow = ref<AuthenticSoftListRow>({} as AuthenticSoftListRow)
const detailVisible = ref(false)
const categoryList = ref<SoftGroup[]>([])
const totalCount = computed(() => tableRef.value?.total ?? 0)

// 与 onMounted 原逻辑一致：默认最近一个月。必须在 setup 就写好，否则 CmTable 子组件 onMounted 会先调 getList，出现无时间参数的首次请求（见 terminal-view 同注释）。
const defaultMonthRange = defaultAuthenticSoftUsageMonthRangeStrings()

function initialEmbedAuthStatus(): number | undefined {
  if (props.viewMode === TableViewMode.full && props.embedDefaults?.authStatus != null) {
    return props.embedDefaults.authStatus
  }
  return undefined
}

const isFullIdleEmbed = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.idleOnly)
const initialSoftNameFromEmbed =
  props.viewMode === TableViewMode.full && props.embedDefaults?.initialSoftName
    ? String(props.embedDefaults.initialSoftName).trim()
    : ''
const embedRankingWeekRange =
  props.viewMode === TableViewMode.full &&
  !isFullIdleEmbed &&
  props.embedDefaults?.initialDateRange?.length === 2 &&
  props.embedDefaults.initialDateRange[0] &&
  props.embedDefaults.initialDateRange[1]
    ? ([props.embedDefaults.initialDateRange[0], props.embedDefaults.initialDateRange[1]] as [string, string])
    : null
const dateRangeInit = isFullIdleEmbed ? ([] as string[]) : (embedRankingWeekRange ?? defaultMonthRange)
const [rangeStart, rangeEnd] = isFullIdleEmbed ? [undefined, undefined] : useParseTime(dateRangeInit)
const initialDateForForm =
  !isFullIdleEmbed && rangeStart != null && rangeEnd != null
    ? ([new Date(rangeStart * 1000), new Date(rangeEnd * 1000)] as any[])
    : []

const form = reactive<{
  searchKey: string
  date_range?: string[]
  date?: any[]
  start_time?: number
  end_time?: number
  /** 与软件使用统计、RankCard 一致；请求参数仍映射为 soft_group_id */
  softwareCategory?: number
  /** 授权状态筛选，对应接口 auth_status */
  authStatus?: number
}>({
  searchKey: initialSoftNameFromEmbed,
  date_range: dateRangeInit,
  date: initialDateForForm,
  start_time: rangeStart,
  end_time: rangeEnd,
  softwareCategory: undefined,
  authStatus: initialEmbedAuthStatus()
})

const authStatusFilterOptions = computed(() => {
  void locale.value
  return [
    { label: t('genuineSoftwareUsageColumns.authStatus0'), value: 0 },
    { label: t('genuineSoftwareUsageColumns.authStatus1'), value: 1 },
    { label: t('genuineSoftwareUsageColumns.authStatus2'), value: 2 },
    { label: t('genuineSoftwareUsageColumns.authStatus3'), value: 3 }
  ]
})

const formColumns = computed<ObjectFormItem<typeof form, 'date_range' | 'softwareCategory' | 'authStatus'>>(() => {
  void locale.value
  const softGroupOptions = categoryList.value
  return {
    date_range: {
      prop: 'date_range',
      label: t('genuineSoftwareUsage.timeRange'),
      type: FormType.Date,
      dateType: DateType.DateRange,
      colOpt: { style: 'flex:0 0 270px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      dateOpt: {
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('common.startDate'),
        'end-placeholder': t('common.endDate'),
        clearable: Boolean(props.viewMode === TableViewMode.full)
      },
      events: {
        change: (val: string[] | null | undefined) => {
          if (!val || val.length !== 2 || !val[0] || !val[1]) {
            form.date_range = [] as unknown as string[]
            form.date = []
            form.start_time = undefined
            form.end_time = undefined
          } else {
            const [start, end] = useParseTime(val)
            form.start_time = start
            form.end_time = end
            if (start != null && end != null) {
              form.date = [new Date(start * 1000), new Date(end * 1000)] as any[]
            }
          }
          void handleQuery()
        }
      }
    },
    softwareCategory: {
      label: t('genuineSoftwareUsage.softwareCategory'),
      colOpt: { style: 'flex: 0 0 150px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      type: FormType.Select,
      selectOpt: { clearable: true },
      /** 传数组；依赖 softGroupOptions 以便 softGroup 接口返回后下拉更新 */
      dictData: softGroupOptions,
      props: { label: 'group_name', value: 'group_id' },
      events: {
        change: () => {
          void refreshList()
          service.updateEvent.next(form)
        }
      }
    },
    authStatus: {
      prop: 'authStatus',
      label: t('genuineSoftwareUsageColumns.authStatus'),
      colOpt: { style: 'flex: 0 0 150px' },
      hiddenAllLabel: true,
      outSearchFiledFlag: true,
      type: FormType.Select,
      selectOpt: { clearable: true },
      dictData: authStatusFilterOptions.value,
      props: { label: 'label', value: 'value' },
      events: {
        change: () => {
          void refreshList()
          service.updateEvent.next(form)
        }
      }
    }
  }
})

const pageOption = { pageNumName: 'page', pageSizeName: 'limit' }

const defaultRangeFull = defaultAuthenticSoftUsageMonthRangeStrings()
const [defaultStartParsed, defaultEndParsed] = useParseTime(defaultRangeFull)
const defaultStartTime = props.viewMode === TableViewMode.full ? defaultStartParsed : undefined
const defaultEndTime = props.viewMode === TableViewMode.full ? defaultEndParsed : undefined

function resolvedStartEnd() {
  /** full 下用户清空时间后不再回退默认近一月，否则请求仍带 start/end */
  if (props.viewMode === TableViewMode.full && (!form.date_range || form.date_range.length !== 2)) {
    return { start: undefined, end: undefined }
  }
  let fromStart: number | undefined
  let fromEnd: number | undefined
  if (form.date?.[0] && form.date?.[1]) {
    const range = [dayjs(form.date[0]).format('YYYY-MM-DD'), dayjs(form.date[1]).format('YYYY-MM-DD')]
    const [s, e] = useParseTime(range)
    fromStart = s
    fromEnd = e
  }
  return {
    start: unixSecondsOrUndefined(form.start_time) ?? unixSecondsOrUndefined(fromStart) ?? defaultStartTime,
    end: unixSecondsOrUndefined(form.end_time) ?? unixSecondsOrUndefined(fromEnd) ?? defaultEndTime
  }
}

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: listCol(t, 'operation'), width: 100, align: 'left', fixed: 'right' },
    actionButtons: () => [
      {
        type: 'installDetail',
        name: listCol(t, 'detail'),
        opt: { size: FormSize.Small, text: true, type: 'text' },
        disabled: (row?: AuthenticSoftListRow) => !props.hasPermission || !row?.install_count,
      },
    ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
  bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
  columns: [
    { prop: 'soft_name', label: t('genuineSoftwareUsageColumns.softName'), columnOpt: { minWidth: 140 } },
    { prop: 'auth_status', label: t('genuineSoftwareUsageColumns.authStatus'), columnOpt: { minWidth: 108 } },
    { prop: 'install_count', label: t('genuineSoftwareCm.authColInstallStatus'), columnOpt: { minWidth: 200, sortable: 'custom' } },
    { prop: 'avg_duration', label: t('genuineSoftwareUsageColumns.avgUseDuration'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'avg_use_count', label: t('genuineSoftwareUsageColumns.avgUseCount'), columnOpt: { minWidth: 140, sortable: 'custom' } },
    { prop: 'last_active_time', label: t('genuineSoftwareUsageColumns.lastActiveTime'), columnOpt: { minWidth: 168 }, formatter: formatLastActiveColumn }
  ],
  rowKey: 'soft_id',
  showActionBar: false,
  showSearch: false,
  showRightToolbar: true,
  path: 'list',
  totalPath: 'total',
  usePagination: false,
  disableScrollLoad: props.viewMode === TableViewMode.preview,
  scrollLoadThreshold: 10,
  scrollLoadDelay: 100,
  height: props.viewMode === TableViewMode.preview ? undefined : '100%'
  }
})

function getListApi(params: any) {
  if (!props.hasPermission) return Promise.resolve({ list: [], total: 0 })
  const p = params ?? {}
  const idleOnly = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.idleOnly)
  const { start, end } = idleOnly ? { start: undefined, end: undefined } : resolvedStartEnd()
  const req: AuthenticRequestParams = {
    soft_name: form.searchKey || '',
    start_time: start,
    end_time: end,
    soft_group_id: form.softwareCategory ?? 0,
    auth_status: form.authStatus,
    page: p.page || 1,
    limit: props.viewMode === TableViewMode.preview ? 10 : 20,
    sort: idleOnly ? 'last_active_time' : (p.sort || 'install_count'),
    asc: idleOnly ? true : (p.asc ?? false),
    ...(idleOnly ? { idle_only: 1 } : {})
  }
  return service.getAuthenticSoftList(req)
}

async function handleSearch(value: string) {
  form.searchKey = value
  await refreshList()
}

async function handleQuery() {
  await refreshList()
}

function handleReset() {
  form.searchKey = props.embedDefaults?.initialSoftName
    ? String(props.embedDefaults.initialSoftName).trim()
    : ''
  // full 模式：闲置嵌入保持无时间区间；否则重置为最近一个月；preview 清空日期
  if (props.viewMode === TableViewMode.full) {
    if (props.embedDefaults?.idleOnly) {
      form.date_range = []
      form.date = []
      form.start_time = undefined
      form.end_time = undefined
    } else if (
      props.embedDefaults?.initialDateRange?.length === 2 &&
      props.embedDefaults.initialDateRange[0] &&
      props.embedDefaults.initialDateRange[1]
    ) {
      const range = [props.embedDefaults.initialDateRange[0], props.embedDefaults.initialDateRange[1]] as [string, string]
      const [s, e] = useParseTime(range)
      if (s != null && e != null) {
        form.date_range = range
        form.date = [new Date(s * 1000), new Date(e * 1000)] as any[]
        form.start_time = s
        form.end_time = e
      }
    } else {
      const range = defaultAuthenticSoftUsageMonthRangeStrings()
      const [s, e] = useParseTime(range)
      if (s != null && e != null) {
        form.date_range = range
        form.date = [new Date(s * 1000), new Date(e * 1000)] as any[]
        form.start_time = s
        form.end_time = e
      }
    }
  } else {
    form.date_range = []
    form.date = []
    form.start_time = undefined
    form.end_time = undefined
  }
  form.softwareCategory = undefined
  form.authStatus = initialEmbedAuthStatus()
  void refreshList()
  service.updateEvent.next(form)
}

function handleViewAll() {
  if (!props.hasPermission) return
  emits('viewAll')
}

function handleUsageExport(type: 0 | 1) {
  if (!props.hasPermission) return
  const idleOnly = props.viewMode === TableViewMode.full && Boolean(props.embedDefaults?.idleOnly)
  const { start, end } = idleOnly ? { start: 0, end: 0 } : resolvedStartEnd()
  const req: AuthenticRequestParams = {
    soft_name: form.searchKey || '',
    start_time: start,
    end_time: end,
    soft_group_id: form.softwareCategory ?? 0,
    auth_status: form.authStatus,
    sort: idleOnly ? 'last_active_time' : 'install_count',
    asc: idleOnly,
    page: 0,
    limit: 0,
    ...(idleOnly ? { idle_only: 1 } : {})
  }
  service.download(type, req, t('genuineSoftwareUsage.exportFilenameUsageSoftwareView'))
}

function cmSlotRow(scope: unknown): AuthenticSoftListRow | undefined {
  if (scope && typeof scope === 'object' && 'row' in scope) {
    return (scope as { row: AuthenticSoftListRow }).row
  }
  return undefined
}

function formatLastActiveColumn(_row: AuthenticSoftListRow, value: unknown) {
  if (value == null || value === '') return '--'
  if (typeof value === 'number') return formatTimeStamp(String(value), 'YYYY-MM-DD HH:mm') || '--'
  if (typeof value === 'string' && /^\d+$/.test(value.trim())) return formatTimeStamp(value, 'YYYY-MM-DD HH:mm') || '--'
  return String(value)
}

function authStatusTagType(s: number): 'info' | 'success' | 'warning' | 'danger' {
  const map: Record<number, 'info' | 'success' | 'warning' | 'danger'> = {
    0: 'danger',
    1: 'warning',
    2: 'success',
    3: 'info'
  }
  return map[s] ?? 'info'
}

function authStatusLabel(s: number) {
  const keys = [
    'genuineSoftwareUsageColumns.authStatus0',
    'genuineSoftwareUsageColumns.authStatus1',
    'genuineSoftwareUsageColumns.authStatus2',
    'genuineSoftwareUsageColumns.authStatus3'
  ] as const
  return keys[s] != null ? t(keys[s]) : '--'
}

function formatMaybeCount(v: number | undefined) {
  if (v == null || !Number.isFinite(v)) return '--'
  return String(v)
}

function formatMaybeDurationMinutes(minutes: number | undefined) {
  if (minutes == null || !Number.isFinite(minutes)) return '--'
  const s = formatDuration(minutes * 60)
  return s || '--'
}

/** 与正版授权列表安装情况进度条一致：已安装数 / 授权台数 */
function installAuthPercent(row: AuthenticSoftListRow): number {
  const auth = row.auth_count ?? 0
  const inst = row.install_count ?? 0
  if (!auth) return inst > 0 ? 100 : 0
  return Math.min(100, (inst / auth) * 100)
}

function showDetail(row: AuthenticSoftListRow) {
  if (!props.hasPermission) return
  activeRow.value = row
  detailVisible.value = true
}

function handleTableAction(payload: { type?: string; rowItem?: AuthenticSoftListRow }) {
  if (!props.hasPermission) return
  if (payload.type === 'installDetail' && payload.rowItem) {
    showDetail(payload.rowItem)
  }
}

function refreshData() {
  void refreshList()
  service.updateEvent.next(form)
}

function loadCategoryList() {
  if (!props.hasPermission) return
  service.softGroup().then((res) => {
    categoryList.value = res.list || []
  })
}

watch(locale, () => {
  loadCategoryList()
})

onMounted(async () => {
  loadCategoryList()
  await nextTick()
  service.updateEvent.next(form)
})

__expose({
  refreshData,
  pagination: computed(() => ({ total: totalCount.value })),
  searchParams: form,
  sortParams: computed(() => ({}))
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "table-opt": tableOpt.value,
      "table-act-opt": tableActOpt.value,
      api: getListApi,
      "has-permission": __props.hasPermission,
      modelValue: form,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form) = $event)),
      "page-option": pageOption,
      onHandleAction: handleTableAction
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: form,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form) = $event)),
          "form-columns": formColumns.value,
          disabled: !__props.hasPermission,
          "show-search": true,
          "sync-search-from-field": "searchKey",
          "search-placeholder": _ctx.$t('genuineSoftwareUsage.searchPlaceholderSoftware'),
          "popover-threshold": 0,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, {
          actions: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(ExportDropdown, {
                "button-text-i18n-key": "genuineSoftwareUsage.exportUsage",
                "has-permission": __props.hasPermission,
                disabled: !totalCount.value,
                onExport: handleUsageExport
              }, null, 8, ["has-permission", "disabled"]),
              _createVNode(InstallStatisticsExport, { "has-permission": __props.hasPermission }, null, 8, ["has-permission"])
            ]),
            (props.viewMode === _unref(TableViewMode).preview)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "",
                  size: "small",
                  class: "cm-ui-ml10",
                  plain: "",
                  onClick: handleViewAll,
                  disabled: !__props.hasPermission
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('genuineSoftwareUsage.viewAll')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
      ]),
      auth_status: _withCtx((scope) => [
        (cmSlotRow(scope)?.auth_status !== undefined && cmSlotRow(scope)?.auth_status !== null)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              size: "small",
              type: authStatusTagType(cmSlotRow(scope)!.auth_status)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(authStatusLabel(cmSlotRow(scope)!.auth_status)), 1)
              ]),
              _: 2
            }, 1032, ["type"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "--"))
      ]),
      "install_count-header": _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('genuineSoftwareCm.authInstallStatusHeader')) + " ", 1),
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('genuineSoftwareCm.authInstallStatusTooltip')), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("i", null, [
              _createVNode(_component_CmSvgIcon, {
                name: "assets/icons/warn-border-gray",
                size: 18,
                monochrome: ""
              })
            ])
          ]),
          _: 1
        })
      ]),
      install_count: _withCtx((scope) => [
        (cmSlotRow(scope))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_progress, {
                class: _normalizeClass(cmSlotRow(scope)!.install_count > cmSlotRow(scope)!.auth_count ? 'red' : 'blue'),
                percentage: installAuthPercent(cmSlotRow(scope)!),
                "show-text": false,
                color: "linear-gradient(270deg, #E54545 1.18%, #FF8282 98.82%)"
              }, null, 8, ["class", "percentage"]),
              _createElementVNode("span", null, _toDisplayString(cmSlotRow(scope)!.install_count) + "/" + _toDisplayString(cmSlotRow(scope)!.auth_count), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
      ]),
      avg_use_count: _withCtx((scope) => [
        (cmSlotRow(scope))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(formatMaybeCount(cmSlotRow(scope)!.avg_use_count)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, "--"))
      ]),
      avg_duration: _withCtx((scope) => [
        (cmSlotRow(scope))
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(formatMaybeDurationMinutes(cmSlotRow(scope)!.avg_duration)), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_8, "--"))
      ]),
      _: 1
    }, 8, ["table-opt", "table-act-opt", "has-permission", "modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
      "destroy-on-close": "",
      size: "65%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('genuineSoftwareUsage.installedTerminals', { name: activeRow.value.soft_name })), 1),
        _createVNode(InstalledDetail, {
          "software-key": activeRow.value.soft_hash_key,
          "software-id": activeRow.value.soft_id,
          "software-name": activeRow.value.soft_name,
          date: form.date,
          "has-permission": __props.hasPermission
        }, null, 8, ["software-key", "software-id", "software-name", "date", "has-permission"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})